/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEditUserMutation, useGetUserQuery } from 'store/api/version-api.slice';
import { getParameterByName } from 'utils';

import LineStyle from './components/LineStepConnector';
import StepIcons from './components/StepIcons';
import { ONBOARDING_STEPS } from './constants';
import { getActiveStep } from './helpers';
import { styles } from './styles/onboard.styles';

const Onboard = () => {
	const [activeStep, setActiveStep] = useState(1);

	const [editUser, { isLoading: isEditLoading }] = useEditUserMutation();

	const navigate = useNavigate();

	const { data: user } = useGetUserQuery();
	const onboardingStep = user?.next_url;

	const ActiveStepComponent = getActiveStep(activeStep);

	const handleNext = useCallback(async () => {
		if (activeStep !== 0) {
			await editUser({ next_url: activeStep + 1 });

			setActiveStep(activeStep + 1);
		}
	}, [activeStep, editUser]);

	const handlePrev = useCallback(async () => {
		if (activeStep !== 1) {
			await editUser({ next_url: activeStep - 1 });

			setActiveStep(activeStep - 1);
		}
	}, [activeStep, editUser]);

	useEffect(() => {
		if (activeStep === 0)
			navigate('/dashboard', {
				replace: true
			});
	}, [navigate, activeStep]);

	useEffect(() => {
		if (typeof onboardingStep === 'number') {
			setActiveStep(onboardingStep);
		}
	}, [onboardingStep]);

	useEffect(() => {
		document.title = 'Member Center - Onboarding';

		window._hsq = window._hsq || [];

		const { _hsq } = window;

		_hsq.push(['setPath', '/onboarding']);
		_hsq.push(['trackPageView']);
		_hsq.push([
			'identify',
			{
				email: getParameterByName('email'),
				onboarding_stage: 'link_accounts'
			}
		]);
	}, []);

	return (
		<Box sx={styles.mainWrapper}>
			<Stepper alternativeLabel activeStep={activeStep} connector={<LineStyle />}>
				{ONBOARDING_STEPS.map(label => (
					<Step key={label}>
						<StepLabel StepIconComponent={StepIcons}>{label}</StepLabel>
					</Step>
				))}
			</Stepper>
			<Container maxWidth="lg" sx={styles.container}>
				<ActiveStepComponent handleNext={handleNext} handlePrev={handlePrev} isNavigating={isEditLoading} />
			</Container>
		</Box>
	);
};

export default Onboard;
